<!--页脚-->
<template>
  <div class="footer-body">
    <el-row class="middle">
      <el-col class="middleRight">
        <el-row type="flex" justify="center">
          <el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2"></el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <div class="footer-main">

              <el-row class="middle">
                <el-col class="middleRight">
                  <el-row type="flex" justify="center">
                    <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="footer-box">
                        <div class="footer-box-info">
                          <div>网络技术支持</div>
                          <div>厦门芯曙光科技有限公司</div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="footer-box teacher-info">
                        <!-- <div class="footer-box-info">
                          <div><b>杨旸老师</b></div>
                          <div>手机：18518635618</div>
                          <div style="margin-bottom: 2vw;">邮箱：ricdyihui@lacricd.com</div>
                          <div><b>林昶旭老师</b></div>
                          <div>手机：18046255868</div>
                          <div>邮箱：lincx@xmu.edu.cn</div>
                        </div> -->
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                      <div class="footer-box">
                        <div class="footer-box-info">
                          <div @click="goBeian()" style="cursor: pointer;margin-bottom: 0.5rem;">苏ICP备2022031974号-1</div>
                          <div @click="goGovBeian()" style="cursor: pointer;">苏公网安备32011302321821号</div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                </el-col>
              </el-row>


            </div>
          </el-col>
          <el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2"></el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  export default {
    data() {
      return {};
    },

    components: {},

    mounted() {},

    methods: {
      // href="http://www.beian.miit.gov.cn"
      goBeian() {
        let url = 'https://beian.miit.gov.cn/'
        window.location.href = url;
      },


      goGovBeian(){
        let url = 'https://beian.mps.gov.cn/#/query/webSearch'
        window.location.href = url;
      },

    },
  }
</script>
<style scoped>
  .footer-container {
    width: 1600px;
    margin: auto;
    color: #3C4A5D;
    background-color: rgba(255, 255, 255, 0.85);
  }

  .footer-container>.footer-list {
    display: flex;
    align-items: center;
    justify-content: space-around;
    list-style: none;
  }

  .footer-container>.footer-list>.footer-item {
    width: 33%;
    text-align: center;
  }

  .footer-container>.footer-list>.footer-item p {
    font-size: 14px;
  }

  .footer-container>.footer-list>.contact {
    height: 200px;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer-container>ul>.contact>.line {
    height: 80%;
    border-left: 1px solid #e4dfdf;
  }

  .footer-container>ul>.contact>div>div {
    padding: 5px 0;
  }


  /* 新版本 */
  .footer-body {
    position: relative;
    background-color: rgba(255, 255, 255,1);
    margin-top: 2vw;
  }

  .footer-main {
    /* margin-top: 2vw; */
    color: #808080;
  }

  .footer-box {
    height: 15vw;
    /* background-color: red; */
    /* background: hsla(0, 0%, 100%, .6); */
    display: flex;
    align-items: center;
    justify-content: space-around;

  }

  .teacher-info {
    /* border-left: 0.0625rem solid #e4dfdf; */
    /* border-right: 0.0625rem solid #e4dfdf; */
  }

  .footer-box-info {
    text-align: center;
  }

  .footer-box-info div {
    font-size: 0.8vw;
  }

  @media screen and (max-width:1200px) {

    .footer-body {
      margin-top: 10vh;
    }

    .footer-main {
      /* margin-top: 10vh; */
    }
  }

  @media screen and (max-width:768px) {
    .footer-box {
      height: 25vw;
      border-bottom: 0.0625rem solid #808080;
    }

    .teacher-info {
      border-left: 0;
      border-right: 0;
    }

    .footer-box-info div {
      font-size: 2vw;
    }
  }

  @media screen and (max-width:500px) {
    .footer-box {
      height: 40vw;
      border-bottom: 0.0625rem solid #808080;
    }

    .footer-box-info div {
      font-size: 4vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue